import React from 'react'

import { HeadingMedium, FadeIn, Spinner, Panel, Label } from '@pb/components'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import OrderError from 'features/account/purchases/components/OrderError'
import SecondaryAction from 'ui/buttons/SecondaryAction'

import { LOAD_MORE_ORDERS_PAGE_SIZE } from '../../duck/constants'
import { operationLoadMoreOrders, operationExpandOrderForFilter } from '../../duck/operations'
import selectors from '../../duck/selectors'
import Order from '../Order'
import styles from './OrderList.scss'

const OrderList: React.FC<any> = ({
  orderIds = [],
  error,
  expandedOrderId,
  loadingOrderId,
  runKlarnaOp,
  expandOrderById,
  shouldShowLoadMoreButton,
  loadMoreOrders,
  isLoadingMore,
  isLoadMoreUsed,
  title,
  filterName,
}) => (
  <Panel padding="none none l none">
    {orderIds.length > 0 && (
      <Panel padding="xs m">
        <HeadingMedium className={styles.subHeading}>
          {title ? (
            <Label copyKey={title} />
          ) : (
            <Label copyKey="omni.hmxklarna.allpurchases.tab.allpurchases.heading" />
          )}
        </HeadingMedium>
      </Panel>
    )}

    {error ? (
      <OrderError
        headline={<Label copyKey="account.digitalreceipts.sorry" />}
        text={<Label copyKey="account.digitalreceipts.cannot.display.receipts" />}
      />
    ) : (
      <ul>
        {orderIds.map((orderId, i) => (
          <Order
            key={filterName + orderId}
            orderId={orderId}
            // @ts-expect-error ts-migrate(2322) FIXME: Type '{ key: any; orderId: any; iterator: any; exp... Remove this comment to see the full error message
            iterator={isLoadMoreUsed ? i % LOAD_MORE_ORDERS_PAGE_SIZE : i}
            expandedOrderId={expandedOrderId}
            toggleExpandedOrder={() => expandOrderById(orderId)}
            loadingOrderId={loadingOrderId}
            runKlarnaOp={runKlarnaOp}
          />
        ))}
      </ul>
    )}

    {shouldShowLoadMoreButton && (
      <FadeIn delay={75 * orderIds.length}>
        <Panel padding="m m none m">
          <SecondaryAction
            size="large"
            onClick={loadMoreOrders}
            className={styles.loadMoreButton}
            disabled={isLoadingMore}
          >
            <Spinner isRendered={isLoadingMore} containerClassName={styles.spinner} />
            <Label copyKey="account.digitalreceipts.loadmore" />
          </SecondaryAction>
        </Panel>
      </FadeIn>
    )}
  </Panel>
)

OrderList.propTypes = {
  orderIds: PropTypes.array,
  error: PropTypes.bool,
  isLoadMoreUsed: PropTypes.bool,
  isLoadingMore: PropTypes.bool,
  expandedOrderId: PropTypes.string,
  loadingOrderId: PropTypes.string,
  runKlarnaOp: PropTypes.func.isRequired,
  expandOrderById: PropTypes.func.isRequired,
  shouldShowLoadMoreButton: PropTypes.bool.isRequired,
  loadMoreOrders: PropTypes.func.isRequired,
  title: PropTypes.string,
  filterName: PropTypes.string,
}

const mapStateToProps = (state, { filterName }): any => {
  const expandedOrderId = selectors.getExpandedOrderIdForFilter(filterName, state)
  const isLoadingMore = selectors.getIsLoadingMoreForOrderFilter(filterName, state)
  const isLoadMoreUsed = selectors.getIsLoadMoreUsed(state)
  const loadingOrderId = selectors.getLoadingOrderId(state)

  return {
    expandedOrderId,
    isLoadingMore,
    isLoadMoreUsed,
    loadingOrderId,
  }
}

const mapDispatchToProps = (dispatch, { filterName }): any => {
  const expandOrderById = (orderId): any =>
    dispatch(operationExpandOrderForFilter(filterName, orderId))
  const loadMoreOrders = (): any => dispatch(operationLoadMoreOrders(filterName))

  return {
    expandOrderById,
    loadMoreOrders,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(OrderList)
